import React from 'react';
import {WHATSAPP_URL} from '../data/salon';

function WaLink({children, className = '', ...props}) {
  return (
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={className} {...props}>
      {children}
    </a>
  );
}

export const btnPrimary = 'inline-flex items-center justify-center gap-2 rounded-lg bg-[#0B3B36] px-7 py-3.5 text-sm font-semibold text-white transition hover:-translate-y-0.5 hover:bg-[#082b27] hover:shadow-xl';
export const btnAccent = 'inline-flex items-center justify-center gap-2 rounded-lg bg-[#E9A23B] px-7 py-3.5 text-sm font-semibold text-[#0B3B36] transition hover:-translate-y-0.5 hover:bg-[#f0b155] hover:shadow-xl';
export const btnOutline = 'inline-flex items-center justify-center gap-2 rounded-lg border-2 border-[#0B3B36] px-6 py-3 text-sm font-semibold text-[#0B3B36] transition hover:bg-[#0B3B36] hover:text-white';
export const eyebrow = 'text-xs font-bold uppercase tracking-[0.25em] text-[#C8553D]';
export default WaLink;
